import { render, staticRenderFns } from "./TareaActividad.vue?vue&type=template&id=3f597228&"
import script from "./TareaActividad.vue?vue&type=script&lang=js&"
export * from "./TareaActividad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports